module.exports = {"yytx07":{"daobanList":[{"title":"1:是否养老保险参保缴费凭证申请","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、委托他人办理：个人委托书","state":"必要"},{"name":"2、有效身份证件原件","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx07.json
// module id = 1306
// module chunks = 0